<template>

	<div class='button'>
		<slot />
	</div>

</template>


<script setup>


</script>


<style scoped>

	.button
	{
		cursor: pointer;
		transition: background 0.3s;
		width: 22px;
		height: 22px;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		border-radius: 25px;
	}
	.button:hover,
	.button:active
	{
		background: #555;
	}

	.button + .button
	{
		margin-left: 3px;
	}

</style>